export default __webpack_public_path__ + "static/media/appointment.22a2ab8d.png";